import { Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { ColumnEditCellTemplateData } from 'devextreme/ui/tree_list';

@Pipe({
  name: 'editCellTemplate',
  standalone: true,
})
export class EditCellTemplatePipe implements PipeTransform {
  transform(cellTemplates: any[], field: string): any {
    const foundObject = cellTemplates?.find((obj: any) => obj.field === field);
    return foundObject ? foundObject.field : undefined;
  }
}
